import { getCalApi } from "@calcom/embed-react";
import { CAL_NAMESPACE, CAL_LINK, CAL_BRAND_COLOR } from "./config";

export { CAL_NAMESPACE, CAL_LINK };

// Précharge le booking cal.com (connexion + assets) pour une ouverture instantanée.
export async function preloadCal() {
  try {
    const cal = await getCalApi({ namespace: CAL_NAMESPACE });
    cal("ui", {
      cssVarsPerTheme: {
        light: { "cal-brand": CAL_BRAND_COLOR },
        dark: { "cal-brand": CAL_BRAND_COLOR },
      },
      hideEventTypeDetails: false,
      layout: "month_view",
    });
    cal("preload", { calLink: CAL_LINK });
  } catch {
    /* préchargement best-effort */
  }
}
